/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { isBefore, startOfDay } from "date-fns";
import { useFieldValue } from "formik";
import * as Yup from "yup";
import { getFormDatesByCases } from "../hooks/useSiblingFormDates";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { getMinAssessmentDate, getMinDateMessage } from "../utils/get-min-assessment-date";
import { GeneralFieldController } from "./general-field-controller";

export class AdverseEventAssessmentDateFieldController extends GeneralFieldController {
	override useControlProps(): FlexControlProps {
		const minDate = () => {
			const { maxCBAssessmentDate, responseAssessmentDate, startingFormAssessmentDate } = getFormDatesByCases(
				this.parent.context.cases,
				this.parent.context.flexEntity?.createdOn
			);

			getMinAssessmentDate(maxCBAssessmentDate, responseAssessmentDate, startingFormAssessmentDate);
		};

		const [responseAssessmentDate] = useFieldValue(AttributeIdentifiers.ResponseAssessmentDate);
		const [benefitAssessmentDate] = useFieldValue(AttributeIdentifiers.BenefitAssessmentDate);
		const today = startOfDay(new Date());
		const minAssessmentDate = benefitAssessmentDate ? minDate() : null;
		const maxAssessmentDate = responseAssessmentDate || benefitAssessmentDate || today;

		return {
			maxDate: maxAssessmentDate,
			minDate: minAssessmentDate,
		};
	}

	override createValidationRule(_initialData: unknown, translate: (key: string) => string) {
		function renderAdverseEventRequiredError() {
			return `${translate("adverse-event-assessment-date")} ${translate("valid-date-message")}`;
		}

		const isResponseAssessmentDateInSameEntity = this.parent.context.entityType.catalogueAttributes.some(
			(attribute) => attribute.identifier === AttributeIdentifiers.ResponseAssessmentDate
		);
		const dates = getFormDatesByCases(this.parent.context.cases, this.parent.context.flexEntity?.createdOn);

		return (this.createFieldValidationRuleByDataType(translate) as Yup.DateSchema)
			.required(renderAdverseEventRequiredError)
			.when("$values", (values: any, schema: Yup.DateSchema) =>
				schema
					.test("is-after-ir-assessment-date", translate("must-be-before-ir-assessment-date"), (v) =>
						v
							? !isResponseAssessmentDateInSameEntity ||
							  isBefore(
									new Date(v),
									new Date(
										values[AttributeIdentifiers.ResponseAssessmentDate] ||
											values[AttributeIdentifiers.BenefitAssessmentDate]
									)
							  )
							: false
					)
					.min(
						getMinAssessmentDate(dates.maxCBAssessmentDate, dates.responseAssessmentDate, dates.startingFormAssessmentDate),
						getMinDateMessage(translate, dates.maxCBAssessmentDate, dates.maxPrescriptionDate, dates.startingFormAssessmentDate)
					)
					.max(new Date(), translate("cannot-be-greater-than-today"))
			);
	}
}
